import "../../../styles/Home/Clients/Clients.css"
import { Slide } from "./Slide";
import { useIntl } from "react-intl";


const generateClientData = (start: number, count: number) => {
    return Array.from({ length: count }, (_, i) => (i + start).toString());
};

const Clients: React.FC = () => {
    const intl = useIntl()

    const TOTAL_LOGOS = 60;
    const LOGOS_PER_ROW = TOTAL_LOGOS / 3;

    const clientsRow1 = generateClientData(1, LOGOS_PER_ROW);
    const clientsRow2 = generateClientData(LOGOS_PER_ROW + 1, LOGOS_PER_ROW);
    const clientsRow3 = generateClientData(LOGOS_PER_ROW * 2 + 1, LOGOS_PER_ROW);

    return (
        <div className="container-fluid bg-clients px-xl-5 container-vertical-padding scroll-reveal sora mt-5" id="clients">
            <h1 dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "CLIENTS.HEADER" }) }} className="mb-5 sora fw-bold">
            </h1>
            <div className="d-flex justify-content-center mb-5">
                <div className="scroll-container">
                    <div className="fade-left" />
                    <Slide clients={clientsRow1} direction="left"></Slide>
                    <Slide clients={clientsRow2} direction="right"></Slide>
                    <Slide clients={clientsRow3} direction="left"></Slide>
                    <div className="fade-right" />
                </div>
            </div>
        </div>
    )
}

export { Clients }